import { RevalidateOptionInterface, ConfigInterface } from "swr"
import { LoadingErrorState } from "../types"
import { SetStateAction } from "react"

function fetchRetryHandler(
    config: ConfigInterface,
    revalidate: (revalidateOpts: RevalidateOptionInterface) => Promise<boolean>,
    revalidateOps: RevalidateOptionInterface,
    setState: (state: SetStateAction<LoadingErrorState | undefined>) => void
) {
    setState("retrying")
    if (
        revalidateOps.retryCount &&
        config.errorRetryCount &&
        revalidateOps.retryCount < config.errorRetryCount
    ) {
        setTimeout(() => {
            revalidate(revalidateOps)
        }, config.errorRetryInterval)
    } else {
        setState("error")
    }
}

export const applyCustomFetchRetryHandler = (
    setErrorState: (
        state: SetStateAction<LoadingErrorState | undefined>
    ) => void
) => ({
    onErrorRetry: (
        err: Error,
        key: string,
        config: ConfigInterface<any, Error>,
        revalidate: (
            revalidateOpts: RevalidateOptionInterface
        ) => Promise<boolean>,
        revalidateOpts: RevalidateOptionInterface
    ) => {
        fetchRetryHandler(config, revalidate, revalidateOpts, setErrorState)
    },
    onSuccess: () => setErrorState(null),
})

export function createPriceValueString(
    price: number | string,
    currency: string = "HUF"
): string {
    let priceValue = ""
    if (typeof price === "number") {
        priceValue = price.toString().replace(".", ",")
    } else if (typeof price === "string") {
        priceValue = Number(price.replace(",", "."))
            .toString()
            .replace(".", ",")
    }

    const currencyMark = currency === "HUF" ? "Ft" : currency
    if (priceValue.includes(",")) {
        const splitNumber = priceValue.split(",")
        return `${thousandSpacing(splitNumber[0])},${
            splitNumber[1]
        } ${currencyMark}`
    }
    return `${thousandSpacing(priceValue)} ${currencyMark}`
}

function thousandSpacing(number: string): string {
    if (number.length <= 3) return number
    else {
        let paddedNumber = ""
        for (let i = 0; i < number.length / 3; i++) {
            let offset = i * 3
            paddedNumber =
                number.substring(
                    number.length - 3 - offset,
                    number.length - offset
                ) +
                " " +
                paddedNumber
        }
        return paddedNumber
    }
}

export function convertTextToNumber(text: string): number {
    if (typeof text === "string" && text.includes(",")) {
        return Number(text.replace(",", "."))
    }
    return Number(text)
}

export function roundTo2Decimal(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100
}

export function isDeviceMobile(): boolean {
    const toMatch = [
        /Android/i,
        /iPhone/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ]

    const isMobile = toMatch.some((toMatchItem) =>
        navigator.userAgent.match(toMatchItem)
    )
    return isMobile
}

export function deriveLoadingErrorState(
    isError: boolean,
    isRefetching: boolean
): LoadingErrorState {
    if (isError) {
        return isRefetching ? "retrying" : "error"
    }
    return null
}

export function isMongoId(id: string): boolean {
    return id.length === 12
}
